/*
 * @Author: cn1994
 * @Date: 2023-09-14 10:18:56
 * @LastEditors: cn1994
 * @LastEditTime: 2024-03-03 15:04:33
 * @Description: file content
 */
const routes = [
  // 学员管理页面
  {
    path: "/member",
    name: "member",
    component: () => import("../pages/educational/students.vue"),
    meta: {
      title: "学员管理",
      hasBack: false,
      volcengine: true,
    },
  },
  // 学员详情
  {
    path: "/member/detail",
    name: "member/detail",
    component: () => import("../pages/educational/students/regular/detail.vue"),
    meta: {
      title: "学员详情",
      hasBack: true,
    },
  },
  // 学员课程进度详情
  {
    path: "/member/coursesProgressDetail",
    name: "member/coursesProgressDetail",
    meta: {
      title: "课程进度详情",
      hasBack: true
    },
    component: () => import("../pages/educational/students/regular/coursesProgressDetail.vue")
  },
  // 学习时长详情
  {
    path: "/member/durationInfo",
    name: "member/durationInfo",
    meta: {
      title: "学习时长详情",
      hasBack: true
    },
    component: () => import("../pages/educational/students/regular/detail/durationInfo.vue")
  },
  {
    // 结课
    path: "/member/endClassList",
    name: "member/endClassList",
    meta: {
      title: "结课"
    },
    component: () => import("../pages/finance/courses/endClassList.vue")
  },
];

export default routes;
